var cozyEcoAdnsUa = window.navigator.userAgent;
var regex = RegExp("Chrome-Lighthouse", "ig");
{
    if (false === regex.test(cozyEcoAdnsUa)) {
        if (!cozyEcoAdnsUa.match(/mobi/i)) {
            function copyToClipboard() {
                var e = document.createElement("input");
                e.setAttribute("value", "Protected"),
                document.body.appendChild(e),
                e.select(),
                document.execCommand("copy"),
                document.body.removeChild(e)
            }
            document.addEventListener("copy", function(e) {
                "input" !== (e.target || e.srcElement).tagName.toLowerCase() && "textarea" !== (e.target || e.srcElement).tagName.toLowerCase() && e.preventDefault()
            }),
            document.addEventListener("cut", function(e) {
                "input" != (e.target || e.srcElement).tagName.toLowerCase() && "textarea" != (e.target || e.srcElement).tagName.toLowerCase() && e.preventDefault()
            });
            const selectTextCss = document.createElement("style");
            selectTextCss.type = "text/css",
            selectTextCss.innerHTML = "body {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}",
            document.head.appendChild(selectTextCss);
            document.addEventListener("dragstart", function(e) {
                return !1
            }),
            document.addEventListener("mousedown", function(e) {
                "img" === (e.target || e.srcElement).tagName.toLowerCase() && 2 == e.which && e.preventDefault()
            }),
            document.addEventListener("contextmenu", function(e) {
                "img" === (e.target || e.srcElement).tagName.toLowerCase() && e.preventDefault()
            });
            const imageDragStyle = document.createElement("style");
            imageDragStyle.type = "text/css",
            imageDragStyle.innerHTML = "img {-webkit-user-drag: none;user-drag: none;}",
            document.head.appendChild(imageDragStyle);
            const disableDragAndDrop = function() {
                document.body.setAttribute("ondragstart", "return false;"),
                document.body.setAttribute("ondrop", "return false;")
            };
            "complete" === document.readyState ? disableDragAndDrop() : document.addEventListener("DOMContentLoaded", disableDragAndDrop);
            // eval("setInterval(function(){ debugger; },1000)");
            let headingStyles = ["color: red", "font-size:1.5rem", "font-weight:700", "padding-top:10px"].join(";", );
            let bodyStyles = ["color: black", "font-size:1.1rem", "font-weight:500", "padding-right:400px", "padding-top:10px", ].join(";");
            let footerStyles = ["color: blue", "font-size:1.2rem", "font-weight:600", "padding-top:10px", "padding-bottom:15px"].join(";");
            let headingText = "LEGAL NOTICE";
            let bodyText = "This website and its content is copyright of Vape Online Store.All rights reserved. Any redistribution or reproduction of any content from this website is strictly prohibited unless being done by explicit consent of the owner.";
            let footerText = "TO PREVENT ANY FURTHER LEGAL ACTION CLOSE THE CONSOLE WINDOW IMMEDIATELY";
            function printConsole(headingText, bodyText, footerText) {
                console.log(`%c${headingText.toUpperCase()} %c${bodyText} %c${footerText.toUpperCase()}`, headingStyles, bodyStyles, footerStyles, );
            }
            // printConsole(headingText, bodyText, footerText);
        } else {
            const bodySelectStyle = document.createElement("style");
            bodySelectStyle.type = "text/css",
            bodySelectStyle.innerHTML = "body {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}",
            document.head.appendChild(bodySelectStyle);
            const imageSelectStyle = document.createElement("style");
            imageSelectStyle.type = "text/css",
            imageSelectStyle.innerHTML = "img {-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;pointer-events: auto;}a > img, span > img {pointer-events: auto;}",
            document.head.appendChild(imageSelectStyle),
            document.addEventListener("contextmenu", function(a) {
                "img" === (a.target || a.srcElement).tagName.toLowerCase() && a.preventDefault()
            });
        }
    }
}
